export const GET_LENDERS_SHARE = 'entities/GET_LENDERS_SHARE'
